'use client';

import { useWindowSize } from 'hooks/dom/useWindowSize';

import { useState } from 'react';
import { ReplayIcon } from 'assets/icons';
import { H2Large } from 'components/powerplugs/styleConstants';
import { Container, useAutoPlayVideoOnIntersection } from 'components/index';
import styles from './VIdeoForCarousal.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const VideoForCarousal = ({
  className,
  title,
  src,
  srcResponsive,
  videoBorderRadius = '0px',
}: {
  className?: string;
  title?: string | React.ReactNode;
  src: string;
  srcResponsive: string;
  videoBorderRadius?: string;
}) => {
  const [replayVisible, setReplayVisible] = useState(false);
  const videoRef = useAutoPlayVideoOnIntersection();
  const { width } = useWindowSize();

  return (
    <section
      className={cx(styles.root, className)}
      data-has-title={title ? 'true' : 'false'}
      style={{
        borderRadius: videoBorderRadius,
        overflow: title ? 'unset' : 'hidden',
      }}
    >
      {title ? (
        <Container>
          <H2Large>{title}</H2Large>
          <p>Get actionable reports and insights every day.</p>
        </Container>
      ) : null}
      <div className={styles.videoContainer}>
        {/* {width < 678 ? srcResponsive : src} */}
        {width < 678 ? (
          <video
            preload="none"
            autoPlay
            loop={false}
            muted
            playsInline={true}
            webkit-playsinline="true"
            ref={videoRef}
            key="mobile"
          >
            <source src={srcResponsive} type="video/mp4" />
          </video>
        ) : (
          <video
            preload="none"
            autoPlay
            muted
            loop={false}
            playsInline={true}
            webkit-playsinline="true"
            ref={videoRef}
            key="desktop"
          >
            <source src={src} type="video/mp4" />
          </video>
        )}
        {replayVisible ? (
          <button
            data-buttontype="animation replay"
            className={styles.replayBtn}
            onClick={() => {
              videoRef.current?.play();
              setReplayVisible(false);
            }}
          >
            <ReplayIcon
              fill="black"
              style={{
                height: '16px',
                width: 'auto',
                opacity: '0.7',
              }}
            />{' '}
            Replay
          </button>
        ) : null}
      </div>
    </section>
  );
};
